module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "CHAPTER 4"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2ch",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('span', {
    staticClass: "bg"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch4"
    }
  }, [_vm._v("CHAPTER 4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("January 1947")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('b', [_vm._v("Y")])]), _c('b', [_vm._v("OU’VE FULLY RECOVERED,")]), _vm._v(" Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir. Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler lifted his left hand and studied the black glove before wiggling his remaining fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’ll never be the same, sir, but it is better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good, that’s very good.” Oberführer Adolf Hahn studied Koehler, who sat stiffly in front of him on an uncomfortable wooden chair, before looking down at the file on the desk and half turning a page. A minute passed before he spoke again, this time not bothering to look up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’re totally healed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think so, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you been on restricted duties now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just over two months, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm.” Hahn returned to reading the file.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler silently puffed out his cheeks once he was sure his boss "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("wouldn’t look up at him. He looked around the office, noting how bare it was compared to his own: no books, no pictures, no plants, no soft settee, no rugs, nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t understand.” Hahn interrupted Koehler’s sightseeing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir?” Koehler whipped his eyes back to his boss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you are fully fit, why are you asking to go back to Germany?” Hahn removed his wire-framed spectacles from his nose, signaling he’d finished with the written request Koehler had spent days composing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As I say in the report, sir, I feel, with respect, that I could do more for the Reich back in Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do say that, but you don’t say why.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t say why you think you’d be more useful in Germany than in London. If it was because you were no longer fit enough to do the job, well, I could understand that, but this . . .” Hahn lifted his index finger and then rested it on the file, as if it were a dagger jabbed into the tabletop. “This doesn’t tell me anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I feel . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You feel? Feelings don’t come into it, Major. Tell me what you "), _c('i', [_vm._v("know.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler shifted on the chair and looked at the brown carpet for inspiration; there wasn’t any there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just thought, sir . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What you "), _c('i', [_vm._v("know,")]), _vm._v(" Major, what you "), _c('i', [_vm._v("know")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, sir, that I’ve been here a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I also know,” Koehler continued, “that my work has been to the highest standard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("“Without doubt.” Hahn nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I think—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn held up his hand for Koehler to stop speaking, and Koehler obliged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That, Major, is the problem. You think. You don’t know, you merely think. Thinking, feeling, wanting: none of that matters when you are a soldier. "), _c('i', [_vm._v("Knowing")]), _vm._v(" matters. Knowing is the key.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know I am tired, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are all tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know I miss my family, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Many men miss their families, Ernst. You still haven’t told me why you are different.” Hahn rested his finger on his temple, waiting for Koehler to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler rocked slightly to the side and then shook his head, looking again at the carpet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to go home, sir; it is that simple. I need to go back to Germany. I can’t do this job anymore. The last few months have shown me that I am not the right person for the role that I’ve been given. I can’t do it; I’m finished.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have been ordered to do your job. The person who orders, it is he who decides when a job is finished, not the person doing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler kept looking at the brown carpet. Tiny lines in the weave made it look like the plowed fields Koehler had seen far below when he had flown out of Moscow back to Berlin all those years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn opened Koehler’s file once more. He picked up a pencil and tapped it on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your family are visiting you, are they not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("“Yes, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When do they go back?” Hahn said without looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Four days, sir.” Koehler’s mood lifted along with his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn leaned back in his chair studying Koehler, who stared back, unsure of what was coming next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are a good soldier, Ernst. Your men would do anything for you, your superiors speak highly of you, and you run a tight ship. Your work with the Jews has been extremely efficient and is to be commended.” Hahn toyed with the pencil again. “Your adventure last year with this Rossett character, exposing those resistance cells, was unconventional but effective. For that work, the Reich and the Führer are extremely grateful. You are being awarded Oak Leaves, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. Well deserved.” Hahn clasped his hands in front of him again, still holding the pencil, which stuck out the top like the plunger on a firing box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn stared at Koehler without speaking, for so long Koehler found himself shifting in the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am I dismissed, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn leaned back from the desk, then tapped the pencil against his teeth before speaking again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not losing faith, are you, Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Faith, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In what we do, and the people we do it for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler stiffened and suddenly regretted writing the transfer request.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("Hahn frowned.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Germany calls on us. The Fatherland makes great demands. Demands that many find difficult to live up to. You’ve been tasked with an unpleasant job—a vital job, but unpleasant nonetheless.” Hahn leaned forward again and lowered his voice. “It would be understandable if your work with the Jews in London became a difficult cross to bear. If you’ll pardon the pun.” Hahn smiled thinly at his own joke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My record speaks for itself, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Records are history. It’s the present I’m talking about, so I’ll ask you again. Are you losing faith?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not losing faith, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn smiled before standing up and wandering over to the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler twisted to look at his boss as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does the business with the Jews offend you, Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all, sir. It is important work that needs to be done,” Koehler replied, surprised to find his eyes straying toward a portrait of the Führer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked away quickly and scratched at his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can speak freely, Ernst. You have my word as an officer that nothing will leave this room,” Hahn said, still staring out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler didn’t reply, for fear of falling into a trap. He noticed his left hand was aching again, and he had to fight the urge to rub it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s been a long war, Ernst,” Hahn said at the window. “For some, longer than others. You are one of those others. I understand that you are tired, and when people are tired, they make mistakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like asking for a fucking transfer, Koehler thought to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("“But you can relax with me here. Here and now, Ernst, in this room, you can speak freely. I’ll ask you again: does this business with the Jews offend you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler turned to look at Hahn, swiveling slightly in his chair. He paused, looked down, and then back up again at Hahn, who still stared out over London from the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Say nothing, Koehler thought. Just say nothing and get the fuck out of this office as soon as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silence sat on his shoulders like a shroud. Hahn didn’t move an inch. Somewhere down a corridor a phone started to ring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually Hahn turned to look at Koehler and smiled like a grandfather—warm, soothing. His face was half in shadow as he waited for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It seems vindictive, sir,” Koehler heard himself say. His heart pounded, one, two, three. He swallowed and spoke again. “We’ve won the war, these people are pathetic, and yet . . . and yet we keep punching them like . . . playground bullies. It seems so pointless. I’ve seen them, I see them every day.” Koehler looked at the carpet and lowered his voice to a whisper. “They aren’t a threat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think the job is done?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler looked up. “I don’t know, sir . . . I’m just struggling to do it. I can’t sleep, I feel guilty, so guilty about it all. I’ve turned into a monster.” Koehler paused, feeling his cheeks flush and pressure build behind his eyes. “Having my family here, it’s made me see myself. What I do to others . . . and what it does to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn crossed the room and sat down on the corner of his desk near to Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you join the SS, Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("“To be the best, sir. I wanted to fight with the best, and to be the best.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not just the uniform?” Hahn smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, a little of that, sir, yes,” Koehler smiled back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I joined in the early days, back in ’33; we had real enemies then, real threats. The Jews and the Bolsheviks were destroying Germany. The enemy was real. You could see them, punch them in the nose, and they punched you back. Now . . .” Hahn chuckled. “The enemy is some frostbitten Russian peasant sitting in a ditch waiting to starve to death. Soon he’ll be gone and we’ll have nobody left to fight.” Hahn took a deep breath and let it out slowly. “Do you know what happens to a warrior who has nobody left to fight?” Hahn didn’t wait for an answer. “He gets fat, fat and lazy, and he starts to question the point of his existence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I . . . I don’t . . .” Koehler trailed off, aware he was lost in a minefield of his own making.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn continued as if he hadn’t spoken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My son died in Moscow, did you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My son.” The smile slipped from Hahn’s lips and Koehler felt his cheeks flush at the intimacy of the moment. Hahn was the third most important German in the country, and one not renowned for his emotions. “Just after the communists fled the city, a sniper they’d left behind got him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn turned to look at Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler didn’t know what to say. His hand hurt like hell and he squeezed it tightly into a fist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("“So much waste.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m tired, too, Ernst. I’ll let you into a secret: I also sometimes question our role, what we are doing. The question vexes me as much as it vexes you.” Hahn looked at Koehler, waiting for a reply that didn’t come. He stood up again, wandered around his desk, and sat back down in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you love your family, Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More than the Führer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love the Führer and my family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t answer the question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn held up a hand, stopping him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s hope you never have to answer that question, Ernst. Thank you for speaking freely. I’m glad we’ve had this conversation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn picked up the pencil again and wrote something in the margin of one of the documents, then shut the file with a flourish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your request for transfer to Germany is denied. I’m going to bounce you upstairs for a few months; you can join the national planning team.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Planning team, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Railway timetables, census work, just paperwork regarding the Jews throughout the country. Basically the sort of stuff you’ve been doing in London, on a slightly larger scale.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn smiled as Koehler slumped a fraction in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It isn’t as bad as it sounds, Ernst. You’ll be deskbound, so you’ll not have to work directly with the Jews. You can just slide them across the tabletop on sheets of paper and keep your hands clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("“Thank you, sir,” Koehler said unconvincingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hahn paused, then steepled his fingers and leaned forward, elbows on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know this is difficult for you, Ernst, but whether you like it or not, you are good at your job. Stick with this for a while and I’ll get you some leave back in Germany with your wife and child. How does that sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’ll keep you away from the Jews, and give me a man I can trust working there to keep an eye on things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will report for duty in five days. That’ll give you time to get your Oak Leaves and say good-bye to your family when they return to Germany.” Hahn slid the file to the far side of his desk and pointed at the door. “You are dismissed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler sat and stared at Hahn for a second, then nodded slowly. He rose, put on his cap, and saluted before making his way to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ernst,” Hahn called, and Koehler turned to face him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are a stunning soldier. You really are one of the best. Germany needs you and I need you. This is important work. We’re sowing the seeds for the future here, remember that. You’ve plenty of fight left in you, you just haven’t realized it yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, sir,” Koehler said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For fuck all, Koehler thought, closing the door behind him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3559cb53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062394613_Chapter_4.vue
// module id = 81
// module chunks = 0